import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "b-plan-table",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_2 = { class: "h-p-2" }
const _hoisted_3 = { class: "h-ml-5" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "b-plan-table_th__users" }
const _hoisted_6 = { ref: "tableBody" }
const _hoisted_7 = { class: "b-plan-table_header" }
const _hoisted_8 = { class: "b-plan-table__full b-plan-table__time--center b-td-no-border" }
const _hoisted_9 = { class: "h-pr-10 h-fw-500" }
const _hoisted_10 = { class: "b-plan-table_th__users b-plan-table_th__users--full-day" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { ref: "tbody" }
const _hoisted_13 = { class: "b-td-no-border" }
const _hoisted_14 = { class: "b-plan-table__time h-pos-rel h-fw-500 h-font-10" }
const _hoisted_15 = ["onMouseover"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlanTableCard = _resolveComponent("PlanTableCard")!
  const _component_AddAnAppointment = _resolveComponent("AddAnAppointment")!
  const _component_drop = _resolveComponent("drop")!
  const _component_UpdateDriveTimePopup = _resolveComponent("UpdateDriveTimePopup")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "table",
    class: _normalizeClass(["b-plan-table__wrapper qa-plan-table", { "b-plan-table__wrapper--full-width": _ctx.isTableFullWidth }])
  }, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("colgroup", null, [
        _cache[1] || (_cache[1] = _createElementVNode("col", { width: "95" }, null, -1)),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (i) => {
          return _createElementVNode("col", {
            key: i,
            class: "b-plan-table__row_color"
          })
        }), 64))
      ]),
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _cache[2] || (_cache[2] = _createElementVNode("td", null, null, -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dates, (date, index) => {
            return (_openBlock(), _createElementBlock("td", {
              key: `${date.toString()}_${index}`
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", {
                  class: _normalizeClass(["b-plan-table_th h-font-12 h-fw-500", { "b-plan-table_th--active": _ctx.compareDates(date) }])
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t(_ctx.getWeekDayMame(date)).substring(0, 3).toUpperCase()) + ". ", 1),
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.getDay(date)), 1)
                ], 2)
              ])
            ]))
          }), 128))
        ]),
        (_ctx.user && _ctx.user.technician_profile && _ctx.user.technician_profile.company_admin)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("td", null, null, -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dates, (date) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: date.toString()
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredUsers, (user) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `${+date}-${user.id}`,
                        style: _normalizeStyle(_ctx.getTdInnerStyle(`${+date}-${user.id}`)),
                        class: "b-plan-table_th__user"
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.$t(_ctx.name(user))) + " ", 1),
                        _createElementVNode("span", {
                          class: "b-plan-table_th__user__label",
                          style: _normalizeStyle({ backgroundColor: user.color })
                        }, null, 4)
                      ], 4))
                    }), 128))
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("tbody", _hoisted_6, [
        _createElementVNode("tr", _hoisted_7, [
          _createElementVNode("td", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('CALENDAR.FULL.DAY')), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dates, (date) => {
            return (_openBlock(), _createElementBlock("td", {
              key: date.toString()
            }, [
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredUsers, (user) => {
                  return (_openBlock(), _createElementBlock("div", {
                    style: _normalizeStyle(_ctx.getTdInnerStyle(`${+date}-${user.id}`)),
                    class: _normalizeClass([{ "b-plan-table_th__users--full-day-prevent": user.is_site }, "b-plan-table_td__user"])
                  }, [
                    _createElementVNode("div", {
                      class: "b-plan-table__time__full_day b-plan-table_th__whole_day__label",
                      style: _normalizeStyle({
                                     borderTop: `5px solid ${_ctx.userColor(user)}`,
                                 }),
                      onClick: ($event: any) => (_ctx.showAddPopup(user, null, date))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getEventsByDate(date, null, user, true, `${+date}-${user.id}`), (cardData, index) => {
                        return (_openBlock(), _createElementBlock("div", null, [
                          (_openBlock(), _createBlock(_component_PlanTableCard, {
                            id: `qa-${cardData.id}`,
                            key: index,
                            class: "b-plan-table__time-card b-plan-table__time-card--full-day h-width-100p qa-time-card",
                            cardData: cardData,
                            wrapperHeight: _ctx.wrapperHeight,
                            onClick: _withModifiers(($event: any) => (_ctx.editEvent({ data: cardData, user })), ["stop"])
                          }, null, 8, ["id", "cardData", "wrapperHeight", "onClick"]))
                        ]))
                      }), 256))
                    ], 12, _hoisted_11)
                  ], 6))
                }), 256))
              ])
            ]))
          }), 128))
        ])
      ], 512),
      _createElementVNode("tbody", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkCalendarViewTime, (data) => {
          return (_openBlock(), _createElementBlock("tr", null, [
            _createElementVNode("td", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                (_ctx.showLine(data))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      style: _normalizeStyle(_ctx.showLineStyles),
                      class: "b-plan-table__timeline__wrapper"
                    }, [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("div", { class: "b-plan-table__timeline" }, null, -1)
                    ]))], 4))
                  : _createCommentVNode("", true),
                (data.calendarViewTime !== "24:00")
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.$t(data.time)), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dates, (date, indexDates) => {
              return (_openBlock(), _createElementBlock("td", { key: indexDates }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["b-plan-table__time-card-wrapper", { "b-plan-table__time-card-wrapper--last": data.calendarViewTime === "24:00" }])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredUsers, (user) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `${+date}-${user.id}`,
                      class: _normalizeClass(["b-plan-table_td__user", _ctx.noPointer ? null : `h-pointer`]),
                      style: _normalizeStyle(_ctx.getTdInnerStyle(`${+date}-${user.id}`, data.time, +date, user.id)),
                      onMouseover: ($event: any) => (_ctx.showTimeAppointmentAdd(data.time, +date, user.id, data.calendarViewTime === "24:00")),
                      onMouseleave: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideTimeAppointmentAdd && _ctx.hideTimeAppointmentAdd(...args)))
                    }, [
                      (_ctx.showAddAppointmentZone({ localTime: data.time, timestamp: +date }) && _ctx.showByIndex === user.id && data.calendarViewTime !== "24:00")
                        ? (_openBlock(), _createBlock(_component_AddAnAppointment, {
                            key: 0,
                            fristHalfTime: _ctx.$t(data.time),
                            choosedDay: `${date}`,
                            userData: user,
                            secondHalfTime: _ctx.secondHalfTime(_ctx.$t(data.time)),
                            onOpenAddAppointmentPopup: _ctx.showAddPopup
                          }, null, 8, ["fristHalfTime", "choosedDay", "userData", "secondHalfTime", "onOpenAddAppointmentPopup"]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getEventsByDate(date, data.time, user, false, `${+date}-${user.id}`, data.calendarViewTime === "24:00"), (cardData, index) => {
                        return (_openBlock(), _createBlock(_component_PlanTableCard, {
                          id: `qa-${cardData.id}`,
                          key: index,
                          timeBlock: data,
                          class: _normalizeClass(["b-plan-table__time-card qa-time-card", {
                                    "b-plan-table__time-card--morning": cardData.start_from_morning,
                                    "b-plan-table__time-card--night": cardData.finish_on_night,
                                    "b-plan-table__time-card--fully": cardData.fully_day,
                                }]),
                          style: _normalizeStyle(_ctx.getStyles(cardData, false)),
                          cardData: cardData,
                          onMouseover: _withModifiers(_ctx.onCardMouseOver, ["stop"]),
                          onMouseleave: _withModifiers(_ctx.onCardMouseLeave, ["stop"]),
                          onDrag: _ctx.onDrag,
                          onDragstart: _ctx.onDragStart,
                          onDragend: _ctx.onDragEnd,
                          onClick: _withModifiers(($event: any) => (_ctx.editEvent({ data: cardData, user })), ["stop"])
                        }, null, 8, ["id", "timeBlock", "class", "style", "cardData", "onMouseover", "onMouseleave", "onDrag", "onDragstart", "onDragend", "onClick"]))
                      }), 128)),
                      (_ctx.driveAvailabilities.length > 0)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.driveAvailabilitiesByDate(user, date, data), (drop) => {
                            return (_openBlock(), _createBlock(_component_drop, {
                              key: drop.dt_start,
                              class: _normalizeClass([{ over: _ctx.driveOver && drop.id === _ctx.driveOver.id }, "b-drop-area"]),
                              tag: "div",
                              style: _normalizeStyle(_ctx.getDropStyles(drop, data)),
                              onDragover: ({ card }, event) => _ctx.onDragOver(drop, event, card),
                              onDragleave: _ctx.onDragLeave,
                              onDrop: _ctx.handleDrop
                            }, null, 8, ["class", "style", "onDragover", "onDragleave", "onDrop"]))
                          }), 128))
                        : _createCommentVNode("", true)
                    ], 46, _hoisted_15))
                  }), 128))
                ], 2)
              ]))
            }), 128))
          ]))
        }), 256))
      ], 512)
    ]),
    (_ctx.showUpdateDrivePopup)
      ? (_openBlock(), _createBlock(_component_UpdateDriveTimePopup, {
          key: 0,
          driveUpdateTo: _ctx.driveUpdateTo,
          onUpdateDriveTime: _ctx.updateDriveTime,
          onClose: _ctx.closeUpdateDrivePopup
        }, null, 8, ["driveUpdateTo", "onUpdateDriveTime", "onClose"]))
      : _createCommentVNode("", true)
  ], 2))
}